// extracted by mini-css-extract-plugin
export default {"solicitudes":"Solicitudes_solicitudes__lOcZX","titleContainer":"Solicitudes_titleContainer__TWqw1","row":"Solicitudes_row__cXoEM","dato":"Solicitudes_dato__EX3FA"};